import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button, Label, Select } from 'ui/components/styled';
import { useToasts } from 'hooks';
import { MemberRoles } from 'models';

export const EditMember = ({ member, onClose, onSuccess }) => {
  const [state, setState] = React.useState({ role: member?.role });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.put(
        `/companies/${member?.company?.id}/members/${member?.id}`,
        state
      );
      if (response.status === 200) {
        removeAllToasts();
        successToast('Member updated successfully!');
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Edit Member.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Edit member
        </Title>
      </Container>
      <Container mb="s">
        <Label htmlFor="name" mb="xs">
          User name
        </Label>
        <TextInput
          id="name"
          name="name"
          variant="minimal"
          placeholder="name"
          value={member?.user?.name}
          onChange={handleChange}
          required
          disabled
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="email" mb="xs">
          Email
        </Label>
        <TextInput
          id="email"
          name="email"
          type="email"
          variant="minimal"
          placeholder="Email"
          value={member?.user?.email}
          onChange={handleChange}
          required
          disabled
        />
      </Container>
      <Container mb="m">
        <Label htmlFor="role" mb="xs">
          Role
        </Label>
        <Select
          id="role"
          testId="role"
          placeholder="Role"
          caretColor="primary"
          variant="minimal"
          options={MemberRoles}
          value={state.role}
          onChange={(option) =>
            handleChange({
              target: {
                name: 'role',
                value: option.value,
              },
            })
          }
          required
        />
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="30%" disabled={preventSubmit}>
          Update Member
        </Button>
      </Container>
    </Form>
  );
};
